import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { formatDistanceToNow } from 'date-fns'
import { Announcement } from '@/hooks/useAnnouncements'

interface SimpleAnnouncementCardProps {
  announcement: Announcement
}

export const SimpleAnnouncementCard = ({ announcement }: SimpleAnnouncementCardProps) => {
  return (
    <Card className="w-full h-32 overflow-hidden flex flex-col">
      <CardHeader className="pb-1 pt-3">
        <div className="flex items-start justify-between">
          <div className="text-lg font-semibold leading-none tracking-tight">{announcement.title}</div>
          <Badge variant={announcement.status === 'active' ? 'default' : 'secondary'}>
            {announcement.status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col justify-between pt-1 pb-3">
        <p className="text-sm text-muted-foreground line-clamp-2 mb-2">{announcement.content}</p>
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>
            {formatDistanceToNow(new Date(announcement.created_at), { addSuffix: true })}
          </span>
        </div>
      </CardContent>
    </Card>
  )
}